<div class="modal-content">
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4>{{ isEdit ? "Rename" : "Add New" }} Boundbook</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModal()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-4">
    <div class="mb-4">
      <input
        type="text"
        class="form-control modern-input"
        placeholder="Boundbook Name"
        [(ngModel)]="boundbook_name"
        #nameInput
        (keyup.enter)="submitClick()"
      />
    </div>

    <div class="d-flex justify-content-end gap-3 mt-4">
      <button
        type="button"
        class="btn modern-btn primary-btn px-4"
        (click)="submitClick()"
        [disabled]="!boundbook_name?.trim()"
      >
        {{ isEdit ? "Save" : "Add Boundbook" }}
      </button>
      <button
        type="button"
        class="btn modern-btn secondary-btn px-4"
        (click)="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
